import { useRef } from "react";
import type { TextInput } from "react-native";
import { type InputProps, Theme } from "tamagui";
import { useForwardFocus } from "../../utils/useForwardFocus";
import { FieldError } from "../FieldError";
import { BentoInput } from "./inputParts";
type Props = {
  id?: string;
  label?: string;
  errorMessage?: string;
  // Tamagui flex issue with applying flex to the input itself on web does not work
  // so we need to apply it to the parent container. To limit its effect to
  // other components, we use a prop to toggle it.
  flexFullInput?: boolean;
} & InputProps;
export function FormInput({
  id,
  label,
  errorMessage,
  disabled,
  flexFullInput = false,
  ...inputProps
}: Props) {
  const inputRef = useRef<TextInput | null>(null);
  const focusTrigger = useForwardFocus(inputRef);
  return <Theme name={errorMessage ? "red_alt2" : "granted"} data-sentry-element="Theme" data-sentry-component="FormInput" data-sentry-source-file="FormInput.tsx">
      <BentoInput id={id} {...flexFullInput ? {
      flex: 1
    } : {}} data-sentry-element="BentoInput" data-sentry-source-file="FormInput.tsx">
        {label ? <BentoInput.Label htmlFor={id} size="$3" pb="$3">
            {label}
          </BentoInput.Label> : null}
        <BentoInput.Box disabled={disabled} {...focusTrigger} data-sentry-element="BentoInput.Box" data-sentry-source-file="FormInput.tsx">
          <BentoInput.Area
        // Text Area form inputs should always default to have label styling for spacing
        hasLabel={true} overflow="hidden" flex={1} unstyled placeholderTextColor="alt1" disabled={disabled} ref={inputRef} {...inputProps} data-sentry-element="BentoInput.Area" data-sentry-source-file="FormInput.tsx" />
        </BentoInput.Box>
        <FieldError message={errorMessage} data-sentry-element="FieldError" data-sentry-source-file="FormInput.tsx" />
      </BentoInput>
    </Theme>;
}